// masks.ts
export const einMask = {
  mask: "##-#######",
};

export const ssnMask = {
  mask: "###-##-####",
};

export const phoneMask = {
  mask: "1 ### ### ####",
  eager: true,
};

export const vinCodeMask = {
  mask: "*****************",
};

export const stateShortMask = {
  mask: "@@",
  tokens: {
    "@": {
      pattern: /[a-zA-Z]/,
      transform: (char: string) => char.toUpperCase(),
    },
  },
};

export const yearMask = {
  mask: "####",
};

export const numberMask = {
  mask: "#*",
};

export const timeMask = {
  mask: "A#:MN",
  tokens: {
    A: { pattern: /[0-2]/ },
    M: { pattern: /[0-5]/ },
    N: { pattern: /[0-9]/ },
  },
};

export const zipMask = {
  mask: "*******",
};

export const licensePlateMask = {
  mask: "**********",
};

export const yearFromMask = {
  mask: "****",
};

export const licenseStateMask = {
  mask: "@@",
  tokens: {
    "@": {
      pattern: /[a-zA-Z]/,
      transform: (char: string) => char.toUpperCase(),
    },
  },
};
